import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export default () => {
	const ref = useRef(null);
	const [width, setWidth] = useState(0);

	useEffect(() => {
		const resizeObserver = new ResizeObserver(([entry]) => {
			requestAnimationFrame(() => {
				if (!entry) {
					return;
				}
				setWidth(entry.target.getBoundingClientRect().width);
			});
		});

		if (ref.current) {
			resizeObserver.observe(ref.current);
		}

		return () => {
			resizeObserver.disconnect();
		};
	}, []);

	return { ref, width };
};
